import request from '@/utils/request'
import Vue from 'vue'
import store from '../store'
const vueObject = new Vue({
    store,
});

var baseUrl = vueObject.$store.getters.getConfig.requestUrl
var chatUrl = vueObject.$store.getters.getConfig.chatUrl
    // var userInfo = vueObject.$store.getters.getUserInfo
    // if (userInfo != false) {
    //     config.headers.token = sessionStorage.getItem('token')
    // }
    // var token = sessionStorage.getItem('token')
    // var token = vueObject.$store.getters.token
    // 根据Id查询打印数据
export function getPrintDataById(data, url, token1) {
    return request({
        url: baseUrl + '/' + url,
        method: 'post',
        data,
        headers: {
            token: token1
        }
    })
}
// 提取方案
export function queryExtractPlan(data) {
    return request({
        url: baseUrl + '/extract/queryExtractPlanAll',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}
// 检索方案
export function querySearchPlan(data) {
    return request({
        url: baseUrl + '/search/querySearchPlan',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}
// 表单校验规则
export function queryFromRules(data) {
    return request({
        url: baseUrl + '/fromrule/queryAll',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}


// 文件管理上传图片
export function upFile(data,token) {
    return request({
        method: 'post',
        data,
        url: baseUrl + '/upload/fileupload',
        headers: {
            'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq',
            token: token
        },

    })
}

// 新增打印方案
export function addPrintPlan(data, token) {
    return request({
        url: baseUrl + '/printsolutions/add',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}

// 修改打印方案
export function updatePrintPlan(data, token) {
    return request({
        url: baseUrl + '/printsolutions/update',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}

// 删除打印方案
export function delPrintPlan(data, token) {
    return request({
        url: baseUrl + '/printsolutions/delete',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}

// 打印次数
export function printRecordAdd(data, token) {
    return request({
        url: baseUrl + '/printRecord/add',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}

// 导出次数
export function exportRecordAdd(data, token) {
    return request({
        url: baseUrl + '/exportRecord/add',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}

// 获取打印次数
export function queryPrintCount(data, token) {
    return request({
        url: baseUrl + '/printData/queryPrintCount',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}

// 聊天历史记录
export function getChatRecord(data, token) {
    return request({
        url: chatUrl + '/chatManage/getChatRecord',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}
// 聊天历史记录
export function latelyUser(data, token) {
    return request({
        url: chatUrl + '/chatManage/latelyUser',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}
// 聊天联系人列表
export function getChatManage(data, token) {
    return request({
        url: chatUrl + '/chatManage/query',
        method: 'post',
        data,
        headers: {
            token: token
        }
    })
}